// components/templates/sections/PROCESS_COFFEE.tsx
import React from "react";
import { useDesign } from "@/context/DesignContext";

type Step = { step: string; title: string; desc: string };
type ProcessProps = { steps?: Step[] | string; design?: any };

export default function PROCESS_COFFEE({ steps = [], design: propDesign }: ProcessProps) {
  const contextDesign = useDesign();
  const design = propDesign || contextDesign;
  const stepsArray = Array.isArray(steps) ? steps : [];
  if (stepsArray.length === 0) return null;

  const bgColor = design?.colors?.background || "#0C0500";
  const primaryColor = design?.colors?.primary || "#C8622A";
  const textColor = design?.colors?.text || "#F5E6D3";
  const textLightColor = design?.colors?.textLight || "#BFA76A";
  const containerMaxWidth = design?.spacing?.containerMaxWidth || "1280px";

  return (
    <section id="brew" className="py-32" style={{ background: `linear-gradient(180deg, ${bgColor} 0%, #110700 100%)` }}>
      <div className="mx-auto px-8" style={{ maxWidth: containerMaxWidth }}>
        <div className="text-center mb-20">
          <div className="font-mono-custom text-xs tracking-[0.5em] uppercase mb-4" style={{ color: primaryColor }}>◈ How We Work</div>
          <h2 className="font-display text-6xl font-black" style={{ color: textColor }}>The Process</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stepsArray.map((p, i) => (
            <div key={p.step} className="relative group">
              {i < stepsArray.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-full w-full h-px -translate-y-1/2 z-0"
                     style={{ background: `linear-gradient(90deg, ${primaryColor}66, transparent)` }} />
              )}
              <div className="relative z-10">
                <div className="font-display text-6xl font-black mb-4 transition-colors duration-500"
                     style={{ color: `${primaryColor}66` }}
                     onMouseEnter={(e) => e.currentTarget.style.color = `${primaryColor}99`}
                     onMouseLeave={(e) => e.currentTarget.style.color = `${primaryColor}66`}>
                  {p.step}
                </div>
                <div className="w-12 h-px mb-6 transition-all duration-500 group-hover:w-20" style={{ background: `linear-gradient(90deg, ${primaryColor}, transparent)` }} />
                <h3 className="font-display text-2xl font-bold mb-3" style={{ color: textColor }}>{p.title}</h3>
                <p className="leading-relaxed text-sm" style={{ fontStyle: "italic", color: `${textLightColor}66` }}>{p.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}